/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Origin_TitleInputs */

const en_road_dude_origin_title = /** @type {(inputs: Road_Dude_Origin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Hit the Road Dude AI?`)
};

const zh_road_dude_origin_title = /** @type {(inputs: Road_Dude_Origin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit the Road Dude AI 是什么？`)
};

/**
* | output |
* | --- |
* | "What is Hit the Road Dude AI?" |
*
* @param {Road_Dude_Origin_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_origin_title = /** @type {((inputs?: Road_Dude_Origin_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Origin_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_origin_title(inputs)
	return zh_road_dude_origin_title(inputs)
});
export { road_dude_origin_title as "road_dude.origin.title" }